import React, {Component} from 'react'
import css from './style.module.css'


class Checktag extends Component {
    
    render () {
        const { label, className, style, ...props } = this.props
        
        let classes = [css.checktag]
        if(className)
        classes.push(className)

        return (
            <label>
                <input className={css.checkbox} type="checkbox" {...props} />
                <div className={classes.join(' ')} style={{ ...style }}>{label}</div>
            </label>
        )
    }

}

export default Checktag


// WEBPACK FOOTER //
// ./src/v2SPRINTA/atoms/Form/Checktag/index.js